import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import VideoPreviewSection from './components/VideoPreviewSection';
import ProfessionalExamSection from './components/ProfessionalExamSection';
import CommunityPreviewSection from './components/CommunityPreviewSection';
import CitiesSection from './components/CitiesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import ShopPreviewSection from './components/ShopPreviewSection';
import KaoyanSection from './components/KaoyanSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: '金榜旺财',
      description: '城乡学生互助升学平台，AI智能匹配学伴，高考考研视频课程，爱心捐助',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${SITE_URL}/videos?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: '金榜旺财',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/vite.svg`,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-8888',
        contactType: 'customer service',
        availableLanguage: 'Chinese',
      },
      address: {
        '@type': 'PostalAddress',
        streetAddress: '中关村教育园区A座8楼',
        addressLocality: '海淀区',
        addressRegion: '北京市',
        addressCountry: 'CN',
      },
      sameAs: [],
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const id = 'schema-home';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schemaData);
    document.title = '金榜旺财 - 城乡学生互助升学平台 | 互动交流社区';
    return () => { const s = document.getElementById(id); if (s) s.remove(); };
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pb-16 md:pb-0">
        <HeroSection />
        <CommunityPreviewSection />
        <FeaturesSection />
        <VideoPreviewSection />
        <KaoyanSection />
        <ShopPreviewSection />
        <ProfessionalExamSection />
        <CitiesSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
